<template>
  <div class="settingStaff">
    <navbarStaff />
    <div class="space"></div>
    <b-container>
      <div class="tebs_content">
        <div class="tebs_floting">
          <div class="row">
            <div class="col-5">
              <div class="circle_content">
                <div class="circle_floting">
                  <div class="circle">
                    <span class="circle__btn">
                      <img
                        class="circle_img"
                        :src="require('@/assets/avatars/' + code + '.jpg')"
                        alt=""
                      />
                      <!-- <ion-icon class="pause" name="pause"></ion-icon>
                        <ion-icon class="play" name="play"></ion-icon> -->
                    </span>
                    <span class="circle__back-1"></span>
                    <span class="circle__back-2"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-7">
              <br />
              <div class="segmented-control">
                <input
                  type="radio"
                  name="radio1"
                  v-model="radio_btn"
                  @change="onChange"
                  value=""
                  id="tab-1"
                  checked
                />
                <label for="tab-1" class="segmented-control__1"
                  ><p>VIP Room</p></label
                >

                <input
                  type="radio"
                  name="radio2"
                  v-model="radio_btn"
                  @change="onChange"
                  value="DayOff"
                  id="tab-2"
                />
                <label for="tab-2" class="segmented-control__2"
                  ><p>DayOff</p></label
                >

                <input
                  type="radio"
                  name="radio3"
                  v-model="radio_btn"
                  @change="onChange"
                  value="office"
                  id="tab-3"
                />
                <label for="tab-3" class="segmented-control__3"
                  ><p>Office</p></label
                >

                <div class="segmented-control__color"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="space"></div>
      <br />
      <br />
      <!-- Detail -->
      <!-- All detail-->
      <div class="all-setting" v-if="radio_btn === ''">
        <div class="card-columns">
          <b-row>
            <b-col cols="6"></b-col>
            <b-col cols="6" class="d-flex justify-content-end p-3">
              <b-button
                v-b-modal="'addroom'"
                variant="info"
                style="margin-right: 10px"
              >
                จองห้อง
              </b-button>
            </b-col>
          </b-row>
          <!-- modal -->
          <b-modal
            :id="'addroom'"
            :hide-footer="true"
            :hide-header="true"
            centered
            size="lg"
            padding="0"
          >
            <button
              type="button"
              class="btn-close-on-image"
              aria-label="Close modal"
              @click="$bvModal.hide('addroom')"
            >
              ปิด
            </button>

            <div class="p-4">
              <h5>จองห้อง</h5>
              <br />
              <form
                action=""
                class="form-group mt-6"
                @submit.prevent="addroom()"
              >
                <b-row>
                  <b-col cols="6" class="mb-1">
                    <label for="phone" class="form-label fw-bold text-secondary"
                      >เบอร์โทรศัพท์</label
                    >
                    <input
                      type="phone"
                      class="form-control input-style text-secondary"
                      placeholder="เบอร์โทรศัพท์"
                      maxlength="10"
                      v-model="input_addRoom_phone"
                      id="phone"
                    />
                  </b-col>
                  <b-col cols="6">
                    <label for="name" class="form-label fw-bold text-secondary">
                      ชื่อ-นามสกุล
                    </label>
                    <input
                      type="text"
                      name=""
                      id="name"
                      class="form-control input-style text-secondary"
                      placeholder="ชื่อ-นามสกุล"
                      v-model="input_addRoom_name"
                    />
                  </b-col>

                  <b-col cols="6">
                    <label for="fac" class="form-label fw-bold text-secondary"
                      >คณะ</label
                    >
                    <b-form-select
                      v-model="selectedfac"
                      :options="optionsfac"
                      value-field="fac_code"
                      class="mb-3 input-style"
                      text-field="fac_name"
                      disabled-field="notEnabled"
                      @change="get_branch()"
                      id="fac"
                    >
                      <template #first>
                        <b-form-select-option :value="null" disabled>
                          เลือกคณะ
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-col>

                  <b-col cols="6">
                    <label
                      for="branch"
                      class="form-label fw-bold text-secondary"
                      >สาขาวิชา</label
                    >
                    <b-form-select
                      v-model="selectedbranch"
                      :options="optionsbranch"
                      class="mb-3 input-style"
                      value-field="branch_code"
                      text-field="branch_name"
                      disabled-field="notEnabled"
                      id="branch"
                      :disabled="!optionsbranch || optionsbranch.length === 0"
                    >
                      <template #first>
                        <b-form-select-option :value="null" disabled>
                          เลือกสาขา
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-col>

                  <b-col cols="6">
                    <label
                      for="email"
                      class="form-label fw-bold text-secondary"
                    ></label>
                  </b-col>
                </b-row>
              </form>
            </div>
          </b-modal>
          <!-- end modal -->
          <b-card no-body class="mb-4">
            <b-card-header
              header-tag="header"
              class="bg-dark text-white d-flex justify-content-between align-items-center"
              @click="isOpen2 = !isOpen2"
            >
              <div>VIP Room</div>
              <b-icon :icon="isOpen2 ? 'chevron-up' : 'chevron-down'" />
            </b-card-header>
            <b-collapse v-model="isOpen2">
              <b-table
                striped
                hover
                :items="items"
                :fields="fieldsRoom"
                responsive="sm"
                :per-page="perPageAll"
                :current-page="currentPageAll"
                id="my-table"
                class="p-3"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(stop_date)="data">
                  {{ data.item.stop_date | moment }}
                </template>

                <template #cell(timestop)="data">
                  {{ data.item.start_time | moment }} -
                  {{ data.item.end_time | moment }}
                </template>
              </b-table>
            </b-collapse>
          </b-card>
        </div>
      </div>
      <!-- End all -->
      <!-- room detail-->
      <div class="room-detail" v-if="radio_btn === 'DayOff'">
        <div class="card-columns">
          <b-row>
            <b-col cols="6"></b-col>
            <b-col cols="6" class="d-flex justify-content-end p-3">
              <b-button
                v-b-modal="'dayOff'"
                variant="info"
                style="margin-right: 10px"
              >
                เพิ่มวันหยุด
              </b-button>
            </b-col>
          </b-row>
          <!-- MODAL -->

          <b-modal
            :id="'dayOff'"
            :hide-footer="true"
            :hide-header="true"
            centered
            size="lg"
            padding="0"
          >
            <button
              type="button"
              class="btn-close-on-image"
              aria-label="Close modal"
              @click="$bvModal.hide('dayOff')"
            >
              ปิด
            </button>

            <div class="p-4">
              <h5>เพิ่มวันหยุด</h5>
              <br />
              <form
                action=""
                class="form-group mt-6"
                @submit.prevent="dayoff()"
              >
                <b-row>
                  <b-col cols="12">
                    <h6 class="form-label fw-bold text-secondary">
                      เลือกวันปิดให้บริการ
                    </h6>
                  </b-col>

                  <b-col cols="6" class="mb-1">
                    <label for="date" class="form-label fw-bold text-secondary"
                      >เริ่ม</label
                    >
                    <input
                      type="date"
                      id="date"
                      class="form-control input-style text-secondary"
                      placeholder="เลือกวันที่"
                      v-model="start"
                    />
                  </b-col>

                  <b-col cols="6" class="mb-1">
                    <label for="date" class="form-label fw-bold text-secondary"
                      >สิ้นสุด</label
                    >
                    <input
                      type="date"
                      id="date"
                      class="form-control input-style text-secondary"
                      placeholder="เลือกวันที่"
                      v-model="end"
                    />
                  </b-col>

                  <b-col cols="6" class="mb-1">
                    <label for="title" class="form-label fw-bold text-secondary"
                      >ชื่อเรื่อง</label
                    >
                    <input
                      type="text"
                      id="title"
                      class="form-control input-style"
                      placeholder="ชื่อเรื่อง"
                      v-model="title"
                    />
                  </b-col>

                  <b-col cols="6" class="mb-1">
                    <label for="desc" class="form-label fw-bold text-secondary"
                      >รายละเอียด</label
                    >
                    <input
                      type="text"
                      id="desc"
                      class="form-control input-style"
                      placeholder="รายละเอียดเพิ่มเติม"
                      v-model="desc"
                    />
                  </b-col>

                  <b-col cols="12" class="mb-1">
                    <label for="desc" class="form-label fw-bold text-secondary"
                      >เลือกเวลา</label
                    >
                    <div class="card-columns-three">
                      <div class="card-columns">
                        <!-- เวลาเริ่ม -->
                        <b-form-select
                          v-model="selectedTime_start"
                          :options="optionsTimeStart"
                          value-field="time_start"
                          text-field="timeStart"
                          class="input-style"
                          :disabled="isAllDay"
                        >
                          <template #first>
                            <b-form-select-option :value="null" disabled>
                              เวลาเริ่ม
                            </b-form-select-option>
                          </template>
                        </b-form-select>
                      </div>

                      <div class="card-columns">
                        <!-- เวลาสิ้นสุด -->
                        <b-form-select
                          v-model="selectedTime_end"
                          :options="filteredOptionsEnd"
                          value-field="time_end"
                          text-field="timeEnd"
                          class="input-style"
                          :disabled="isAllDay"
                        >
                          <template #first>
                            <b-form-select-option :value="null" disabled>
                              เวลาสิ้นสุด
                            </b-form-select-option>
                          </template>
                        </b-form-select>
                      </div>

                      <div class="card-columns">
                        <!-- ทั้งวัน -->
                        <b-form-checkbox v-model="isAllDay" switch>
                          ทั้งวัน
                        </b-form-checkbox>
                      </div>
                    </div>
                  </b-col>

                  <b-col cols="12">
                    <!-- หัวข้อ -->
                    <h6 class="mb-3 fw-bold text-secondary">
                      เลือกชั้นที่ต้องการปิดให้บริการ
                    </h6>

                    <!-- กลุ่มปุ่ม -->
                    <div class="d-flex flex-wrap gap-2 justify-content-start">
                      <!-- ปุ่มตัวเลือกอื่น -->
                      <b-button
                        v-for="(option, index) in options"
                        :key="index"
                        :variant="
                          isSelected(option) ? 'orange' : 'outline-orange'
                        "
                        class="rounded-pill px-3"
                        :disabled="selected.all"
                        @click="toggleOption(option)"
                      >
                        {{ option.floor_name }}
                      </b-button>
                      <!-- ปุ่ม All -->
                      <b-button
                        :variant="selected.all ? 'orange' : 'outline-orange'"
                        class="rounded-pill px-3"
                        @click="toggleAll"
                      >
                        ทั้งหมด
                      </b-button>
                    </div>
                  </b-col>

                  <b-col cols="12" class="mt-1">
                    <div class="d-flex justify-content-end gap-2 p-0">
                      <b-button
                        variant="outline-info"
                        type="submit"
                        @click="$bvModal.hide('modal-1')"
                      >
                        ยืนยัน
                      </b-button>
                      <b-button
                        variant="outline-secondary"
                        @click="$bvModal.hide('modal-1')"
                      >
                        ยกเลิก
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </form>
            </div>

            <!-- <div class="card card-order-list card-margin shadow-sm">
              <div class="card-body">
                เพิ่มวันหยุด
              </div>
            </div> -->
          </b-modal>
          <!-- END MODAL -->

          <b-card no-body class="mb-4">
            <b-card-header
              header-tag="header"
              class="bg-dark text-white d-flex justify-content-between align-items-center"
              @click="isOpen1 = !isOpen1"
            >
              <div>วันปิดให้บริการ</div>
              <b-icon :icon="isOpen1 ? 'chevron-up' : 'chevron-down'" />
            </b-card-header>
            <b-collapse v-model="isOpen1">
              <b-table
                striped
                hover
                :items="items"
                :fields="fieldsDayOff"
                responsive="sm"
                :per-page="perPageAll"
                :current-page="currentPageAll"
                id="my-table"
                class="p-3"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(stop_date)="data">
                  {{ data.item.stop_date | moment }}
                </template>

                <template #cell(timestop)="data">
                  {{ data.item.start_time | moment }} -
                  {{ data.item.end_time | moment }}
                </template>
              </b-table>
            </b-collapse>
          </b-card>
        </div>
      </div>
      <!-- end room detail -->
      <!-- office detail-->
      <div class="office-detail" v-if="radio_btn === 'office'">
        <div class="card-columns">
          <b-crad>
            <div>
              <p>ลาป่วย</p>
              <p>ลากิจ</p>
              <p>ลาพักผ่อน</p>
            </div>
          </b-crad>

          <b-card no-body class="mb-4">
            <b-card-header
              header-tag="header"
              class="bg-info text-white d-flex justify-content-between align-items-center"
              @click="isOpen3 = !isOpen3"
            >
              <div>ตารางวันลา</div>
              <b-icon :icon="isOpen2 ? 'chevron-up' : 'chevron-down'" />
            </b-card-header>
            <b-collapse v-model="isOpen3">
              <b-table
                striped
                hover
                :items="items"
                :fields="fieldsOffice"
                responsive="sm"
                :per-page="perPageAll"
                :current-page="currentPageAll"
                id="my-table"
                class="p-3"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(stop_date)="data">
                  {{ data.item.stop_date | moment }}
                </template>

                <template #cell(timestop)="data">
                  {{ data.item.start_time | moment }} -
                  {{ data.item.end_time | moment }}
                </template>
              </b-table>
            </b-collapse>
          </b-card>
        </div>
      </div>

      <!-- end office detail -->
      <!-- end -->
    </b-container>
  </div>
</template>

<script>
import navbarStaff from "../layouts/navbar_staff.vue";
import moment from "moment";
import axios from "axios";
export default {
  components: { navbarStaff },
  data() {
    return {
      radio_btn: "",
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      tokenjong: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",
      code: "",
      items: [],
      input_for_dayoff: {},
      fieldsDayOff: [
        { key: "index", label: "ลำดับ" },
        { key: "stop_date", label: "วันที่ปิดให้บริการ", sortable: true },
        { key: "title", label: "หัวข้อ" },
        { key: "stop_cause", label: "รายละเอียด" },
        { key: "floor_effect", label: "ปิดให้บริการชั้นที่" },
        { key: "timestop", label: "เวลาปิดให้บริการ" },
      ],

      fieldsRoom: [
        { key: "index", label: "ลำดับ" },
        { key: "stop_date", label: "ชื่อผู้ใช้", sortable: true },
        { key: "room", label: "ชื่อห้อง", sortable: true },
        { key: "date", label: "วันที่จอง" },
        { key: "title", label: "เวลาจอง" },
        { key: "floor_effect", label: "ชื่อผู้จอง" },
        { key: "stop_cause", label: "สถานะ" },
      ],

      fieldsOffice: [
        { key: "index", label: "ลำดับ" },
        { key: "title", label: "ชื่อ-นามสกุล" },
        { key: "desc", label: "ฝ่ายงาน" },
        { key: "stop_date", label: "วันที่ลา", sortable: true },
        { key: "title", label: "เรื่อง" },
        { key: "stop_cause", label: "จำนวนวัน" },
        { key: "floor_effect", label: "สถานะ" },
        // { key: "timestop", label: "วันลาคงเหลือ" },
      ],
      perPageAll: 20,
      currentPageAll: 1,
      isOpen1: true,
      isOpen2: true,
      isOpen3: true,
      start: "",
      end: "",
      title: "",
      desc: "",
      selected: {
        all: false,
        items: [],
      },
      options: [
        {
          floor: "1",
          floor_name: "ชั้น 1 อาคาร 13",
        },
        {
          floor: "2",
          floor_name: "ชั้น 2 อาคาร 14",
        },
        {
          floor: "3",
          floor_name: "ชั้น 3 อาคาร 14",
        },
        {
          floor: "4",
          floor_name: "ชั้น 4 อาคาร 14",
        },
        {
          floor: "5",
          floor_name: "ชั้น 5 อาคาร 14",
        },
        {
          floor: "6",
          floor_name: "ชั้น 6 อาคาร 14",
        },
      ],
      selectedTime_start: null,
      selectedTime_end: null,
      isAllDay: false,
      optionsTimeStart: [
        { time_start: "08:30", timeStart: "08:30" },
        { time_start: "13:00", timeStart: "13:00" },
      ],
      optionsTimeEnd: [
        { time_end: "12:00", timeEnd: "12:00" },
        { time_end: "16:30", timeEnd: "16:30" },
      ],

      optionsfac: [],
      selectedfac: null,
      optionsbranch: [],
      selectedbranch: null,
    };
  },
  computed: {
    filteredOptionsEnd() {
      // เงื่อนไขพิเศษ: ถ้าเลือกเวลาเริ่ม = 13:00 ให้เหลือแค่ 16:30
      if (this.selectedTime_start === "13:00") {
        return this.optionsTimeEnd.filter((t) => t.time_end === "16:30");
      }
      return this.optionsTimeEnd;
    },
  },
  watch: {
    // ถ้าเลือกเวลาเริ่มใหม่ ให้ล้างเวลา End ที่ไม่ถูกต้อง
    selectedTime_start(newVal) {
      if (newVal === "13:00") {
        this.selectedTime_end = "16:30";
      } else {
        this.selectedTime_end = null;
      }
    },
    // ถ้าเลือก "ทั้งวัน" ให้ disable และ reset เวลา
    isAllDay(newVal) {
      if (newVal) {
        this.selectedTime_start = null;
        this.selectedTime_end = null;
      }
    },
  },
  methods: {
    dayoff() {
      console.log(
        this.start,
        this.end,
        this.title,
        this.desc,
        this.selectedTime_start,
        this.selectedTime_end,
        this.isAllDay,
        this.selected.items,
        this.selected.all,
      );

      let time_off_start;
      let time_off_end;
      let floor_off_arr = [];
      let data;
      if (this.selected.all === true) {
        floor_off_arr = ["1", "2", "3", "4", "5", "6"];
      } else {
        this.selected.items.forEach((item) => {
          floor_off_arr.push(item.floor);
        });
      }

      if (this.isAllDay === true) {
        time_off_start = "08:30";
        time_off_end = "16:30";
      } else {
        time_off_start = this.selectedTime_start;
        time_off_end = this.selectedTime_end;
      }

      console.log("floor_off == ", floor_off_arr.toString());
      console.log("start = ", time_off_start, "  end=", time_off_end);

      let floor_st = floor_off_arr.toString();

      data = {
        day_start: this.start,
        day_end: this.end,
        stop_title: this.title,
        stop_cause: this.desc,
        time_start: time_off_start,
        time_end: time_off_end,
        floorOff: floor_st,
        audit_user:"",
        audit_ip_add:"",
        floor_effect:"",
        

      };

      console.log("data == ", data);

      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      axios.post("", data, { headers }).then((res) => {
        console.log(res);
      });
    },
    onChange() {
      // console.log(this.radio_btn);
    },
    toggleAll() {
      this.selected.all = !this.selected.all;
      if (this.selected.all) {
        this.selected.items = [];
      }
    },
    toggleOption(option) {
      const idx = this.selected.items.indexOf(option);
      if (idx === -1) this.selected.items.push(option);
      else this.selected.items.splice(idx, 1);
    },
    isSelected(option) {
      return this.selected.items.includes(option);
    },
    //GET : FAC
    get_fac() {
      const token = this.tokenjong;
      let data = {
        token: token,
        search_with_fac_code: "",
      };
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/room/get_faculty", data, {
          headers,
        })
        .then((res) => {
          this.optionsfac = res.data.faculties;
        });
    },
    //GET : Branch
    get_branch() {
      const token = this.tokenjong;
      let data = {
        token: token,
        fac_code: this.selectedfac,
      };
      // console.log(data);
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/room/get_branch_withfac",
          data,
          {
            headers,
          },
        )
        .then((res) => {
          this.optionsbranch = res.data.branches;
        });
    },
  },
  mounted() {
    //
    this.get_fac();
    if (localStorage.getItem("auth") != null) {
      let c = JSON.parse(localStorage.getItem("auth"));
      this.code = c.std_code;
    }
    // this.optionsTimestart = this.time_st.time;
  },
  filters: {
    moment: function (date) {
      moment.locale("th");
      // if (date) {
      //   return moment(String(date)).format("MM/DD/YYYY");
      // }
      return moment(date).add(543, "year").format("LL");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@100;200&display=swap");
.settingStaff {
  background: var(--greyLight-1) no-repeat center center;
  background-size: cover;
  min-height: 100vh;
  position: absolute;
  width: 100%;
}
.btn-close-on-image {
  position: absolute; /* ทำให้ปุ่มทับบนภาพ */
  top: 10px; /* ระยะจากขอบบน */
  right: 10px; /* ระยะจากขอบขวา */
  background: none; /*  พื้นหลังโปร่งใส */
  color: rgb(77, 77, 77);
  border: none;
  /* border-radius: 50%;*/
  width: 32px;
  height: 32px;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 0.2s;
}

.modal-content h5,
h4,
.btn {
  font-family: "Kanit", sans-serif !important;
}
.space {
  height: 100px;
}
.gap-2 {
  gap: 0.5rem;
}
/*  Avatar BUTTON  */
.circle_content {
  position: relative;
}
.circle_img {
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.circle_floting {
  position: absolute;
  top: -10px;
  left: -22px;
  font-size: 14px;
}
.circle {
  grid-column: 2/3;
  grid-row: 4/6;
  width: 8rem;
  height: 100%;
  justify-self: center;
  border-radius: 1rem;
  display: grid;
  grid-template-rows: 1fr;
  justify-items: center;
  align-items: center;
}
.circle__btn {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 9rem;
  height: 6rem;
  display: flex;
  margin: 0.6rem;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 3.2rem;
  color: var(--primary);
  z-index: 300;
  background: var(--greyLight-1);
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  cursor: pointer;
  position: relative;
}
.circle__btn.shadow {
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
}
.circle__btn .play {
  position: absolute;
  opacity: 0;
  transition: all 0.2s linear;
}
.circle__btn .play.visibility {
  opacity: 1;
}
.circle__btn .pause {
  position: absolute;
  transition: all 0.2s linear;
}
.circle__btn .pause.visibility {
  opacity: 0;
}
.circle__back-1,
.circle__back-2 {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  filter: blur(1px);
  z-index: 100;
}
.circle__back-1 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  background: linear-gradient(
    to bottom right,
    var(--greyLight-3) 0%,
    var(--white) 100%
  );
  -webkit-animation: waves 4s linear infinite;
  animation: waves 4s linear infinite;
}
.circle__back-1.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}
.circle__back-2 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  -webkit-animation: waves 4s linear 2s infinite;
  animation: waves 4s linear 2s infinite;
}
.circle__back-2.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}

@-webkit-keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
/*END */
/* tebs content */
.tebs_content {
  position: relative;
}
.tebs_floting {
  position: absolute;
  top: 0px;
  left: 0px;
  font-size: 14px;
}

.segmented-control {
  grid-column: 3/4;
  grid-row: 1/2;
  width: 19.5rem;
  height: 3.4rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  position: relative;
}
.segmented-control input {
  display: none;
}
.segmented-control > input:checked + label {
  transition: all 0.5s ease;
  color: rgb(209, 95, 2);
}
.segmented-control__1,
.segmented-control__2,
.segmented-control__3 {
  width: 6.3rem;
  height: 3.6rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #ff5f2d;
  transition: all 0.5s ease;
  margin-top: 1.5rem;
}
.segmented-control__1:hover,
.segmented-control__2:hover,
.segmented-control__3:hover {
  color: rgb(209, 95, 2);
}
.segmented-control__color {
  position: absolute;
  height: 2.5rem;
  width: 6.6rem;
  margin-left: 0.3rem;
  border-radius: 0.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  pointer-events: none;
}

#tab-1:checked ~ .segmented-control__color {
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-2:checked ~ .segmented-control__color {
  transform: translateX(6rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-3:checked ~ .segmented-control__color {
  transform: translateX(12.2rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/* end*/

/* Card */

.form-group button {
  margin-bottom: 20px;
}
#button {
  border-radius: 30px;
}
.form-group input {
  margin-bottom: 20px;
}
.input-style {
  border-radius: 30px;
  background-color: #ffffff;
  border-color: #cecece;
  color: #000000;
}
.card-header:first-child {
  /* border-radius: 0px; */
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.card-columns .card {
  border-radius: 20px;
}
.card-columns {
  column-count: 1;
}
.card-columns-two {
  column-count: 2;
}
.card-columns-three {
  column-count: 2;
}
.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
.shadow-date {
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
.card-title {
  text-align: left;
  text-align: justify;
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 23px;
  margin-bottom: -5px;
}
.text-muted i {
  margin: 0 5px;
}

@media (max-width: 900px) {
  .circle_floting {
    position: absolute;
    /* width: 46px;
    height: 40px;
    
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 12px; */
    bottom: 0px;
    left: -15px;
    font-size: 14px;
  }
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 1;
  }
  .card-columns-three {
    column-count: 1;
  }
}
@media (min-height: 414px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 1;
  }
  .card-columns-three {
    column-count: 1;
  }
}
@media (max-height: 500px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 1;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 1;
  }
  .card-columns-three {
    column-count: 1;
  }
}
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 2;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 1;
  }

  .card-columns-right-item {
    column-count: 3;
  }
  .time-column {
    column-count: 1;
  }
  h6 {
    margin-top: 10px;
  }
  .card-columns-three {
    column-count: 1;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 2;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 2;
  }
  .card-columns-right-item {
    column-count: 3;
  }
  .time-column {
    column-count: 1;
  }
  h6 {
    margin-top: 10px;
  }
  .card-columns-three {
    column-count: 3;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 2;
  }
  .card-columns-three {
    column-count: 3;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 3;
  }
  .card-columns-right-item {
    column-count: 3;
  }
  .time-column {
    column-count: 1;
  }
  h6 {
    margin-top: 10px;
  }
}
/* */
.btn-outline-orange {
  color: rgb(255, 95, 45);
  border-color: rgb(255, 95, 45);
}

.btn-outline-orange:hover {
  color: #fff;
  border-color: rgb(255, 95, 45);
  background-color: rgb(255, 95, 45);
}
.btn-outline-orange:focus,
.btn-outline-orange.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}
.btn-outline-orange.disabled,
.btn-outline-orange:disabled {
  color: #6c757d;
  border: 1px solid #ced4da;
  background-color: #e9ecef;
}
.btn-outline-orange:not(:disabled):not(.disabled):active,
.btn-outline-orange:not(:disabled):not(.disabled).active,
.show > .btn-outline-orange.dropdown-toggle {
  color: #fff;
  border-color: #000000;
  background-color: #000000;
}
.btn-outline-orange:not(:disabled):not(.disabled):active:focus,
.btn-outline-orange:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-orange.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}

.btn-orange {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange_s);
}

.btn-orange:hover {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange_s);
}
.btn-orange:focus,
.btn-orange.focus {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange_s);
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}
.btn-orange.disabled,
.btn-orange:disabled {
  color: #fff;
  border-color: var(--gray);
  background-color: var(--dark);
}
.btn-orange:not(:disabled):not(.disabled):active,
.btn-orange:not(:disabled):not(.disabled).active,
.show > .btn-orange.dropdown-toggle {
  color: #fff;
  border-color: var(--dark);
  background-color: var(--dark);
}
.btn-orange:not(:disabled):not(.disabled):active:focus,
.btn-orange:not(:disabled):not(.disabled).active:focus,
.show > .btn-orange.dropdown-toggle:focus {
  /*rgba(180, 72, 112, 0.5) rgba(255, 109, 65, 0.468);*/
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}
</style>
>
